import React, { useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

import { Modal, ResourceList, TextField, Icon, Heading, Banner } from '@shopify/polaris';

const propTypes = {
  initialOpen: PropTypes.bool,
  loading: PropTypes.bool,

  errors: PropTypes.array,

  successMessage: PropTypes.string,

  title: PropTypes.string,
  primaryAction: PropTypes.shape({
    content: PropTypes.string,
    onAction: PropTypes.func,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
  }),
  secondaryActions: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.string,
    onAction: PropTypes.func,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
  })),
}

const defaultProps = {
  initialOpen: false,
  errors: []
}

const defaultMessage = { title: null, content: null, status: "success" };

const GeneralModal = forwardRef( (props, ref) => {
  const [open, setOpen] = useState(props.initialOpen);
  const [message, setMessage] = useState({ title: null, content: null, status: "success" });
  
  const openModal = useCallback( () => setOpen(true), []);
  const closeModal = useCallback( () => setOpen(false), []);
  const clearMessage = useCallback( () => setMessage(defaultMessage), []);

  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal, 
    clearMessage: clearMessage,
    setMessage: setMessage,
  }));
  
  return (
    <Modal
      open={ open }
      size="Full"
      large
      title={ props.title }
      onClose={ closeModal }

      primaryAction={ props.primaryAction }
      secondaryActions={ props.secondaryActions }
    >
      <Modal.Section>
        { props.errors.length > 0 &&
          <Banner
            title="Por favor revise los errores e intente nuevamente."
            status="critical"
            onDismiss={ props.onDismissMessage }
          >
            { props.errors.map(( error, index ) =>
              <p key={index}>{error}</p>
            )}
          </Banner>
        }
        { !!message.content && 
          <Banner title={ message.title } status={ message.status || "success" } onDismiss={ clearMessage }>
            { message.content }
          </Banner>
        }

        { props.children }
      </Modal.Section>
    </Modal>
  )
});

GeneralModal.propTypes = propTypes;
GeneralModal.defaultProps = defaultProps;

export default GeneralModal;